export enum LoginAttemptStatus {
  BAD_CREDENTIALS = 1,
  INSUFFICIENT_PRIVILEGES,
  SUCCESS,
  SYSTEM_FAILURE,
  TIMEOUT,
}
